module.exports = __webpack_public_path__ + "6961e07849984ff53554851b568354f1.png";